import AdminOperationsScreen from "../../../src/features/arrangements/screens/AdminOperationsScreen";

export default function AdminCaseRoute() {
  return <AdminOperationsScreen screenIdOverride="case-overview" />;
}
